import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { Stack } from '@zet/design-system/layout'
import { styled } from 'nativewind'

const NotifyIndicatorWrapper = styled(Stack, '')
const Indicator = styled(
  Stack,
  ' w-[9] h-[9] rounded-[4.5] p-[1]   justify-center items-center  absolute right-[2]  '
)

type NotifyIndicatorProps = {
  children: React.ReactNode
  newNotification?: boolean
  onPress: VoidFunction
}

export function NotifyIndicator({
  children,
  newNotification = false,
  onPress,
}: NotifyIndicatorProps) {
  return (
    <PressableWithIntent
      name={'Notification'}
      onPress={onPress}
      eventName="click_action"
      eventPayload={{ item_name: 'home_page_notification' }}
    >
      <NotifyIndicatorWrapper>
        {children}
        {newNotification && (
          <Indicator>
            <Stack className="bg-decorative-navel h-[7] w-[7] rounded-[3.5]" />
          </Indicator>
        )}
      </NotifyIndicatorWrapper>
    </PressableWithIntent>
  )
}
